export default __webpack_public_path__ + "static/media/229.964912c4.png";